import { render, staticRenderFns } from "./BillingAccount.vue?vue&type=template&id=e3f72bf8&scoped=true&"
import script from "./BillingAccount.vue?vue&type=script&lang=ts&"
export * from "./BillingAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BillingAccount.vue?vue&type=style&index=0&id=e3f72bf8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f72bf8",
  null
  
)

export default component.exports